var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ServiceDataBase } from "@/modules/services/models/ServiceData";
import { MapProperty, MapGetMethod, MapSetMethod } from "@/utils/mapper/ClassMapper";
import { SmartAd } from "./PublicDocumentSmartAd";
var PublicDocument = (function (_super) {
    __extends(PublicDocument, _super);
    function PublicDocument() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.organizationLogo = '';
        _this.organizationName = '';
        _this.organizationWebsiteUrl = '';
        _this.blockChainReceiptUrl = '';
        _this.blockChainReceiptUrl2 = '';
        _this.documentImageUrl = '';
        _this.documentPdfUrl = '';
        _this.createDate = '';
        _this.documentRowId = '';
        _this.emissionDate = '';
        _this.isBlockChain = false;
        _this.isBlockChain2 = false;
        _this.isBlockChain2Approved = false;
        _this.isBlockChainSigned = false;
        _this.isBlockChainSigned2 = false;
        _this.isDocumentLandscape = false;
        _this.isDocumentSigned = false;
        _this.isDemo = false;
        _this.isPrivate = false;
        _this.isSuccess = false;
        _this.errors = [];
        _this.isVerified = false;
        _this.keywords = '';
        _this.blockChainReceiptData = '';
        _this.originalDocumentImageUrl = '';
        _this.folderName = '';
        _this.folderTitle = '';
        _this.smartads = [];
        _this.recipientName = '';
        _this.recipientPublicProfileUrl = '';
        _this.recipientPictureUrl = '';
        _this.recipientShortDescription = '';
        _this.publicDocumentRedirectUrl = '';
        _this.isPublicDocumentRedirectActive = false;
        return _this;
    }
    PublicDocument.prototype.setData = function (data) {
    };
    PublicDocument.prototype.getData = function () {
    };
    __decorate([
        MapProperty({ from: 'AcademyLogo' })
    ], PublicDocument.prototype, "organizationLogo", void 0);
    __decorate([
        MapProperty({ from: 'AcademyName' })
    ], PublicDocument.prototype, "organizationName", void 0);
    __decorate([
        MapProperty({ from: 'AcademyWebsite' })
    ], PublicDocument.prototype, "organizationWebsiteUrl", void 0);
    __decorate([
        MapProperty({ from: 'BlockChainReceiptUrl' })
    ], PublicDocument.prototype, "blockChainReceiptUrl", void 0);
    __decorate([
        MapProperty({ from: 'BlockChainReceipt2Url' })
    ], PublicDocument.prototype, "blockChainReceiptUrl2", void 0);
    __decorate([
        MapProperty({ from: 'CertificateImageUrl' })
    ], PublicDocument.prototype, "documentImageUrl", void 0);
    __decorate([
        MapProperty({ from: 'CertificatePdfUrl' })
    ], PublicDocument.prototype, "documentPdfUrl", void 0);
    __decorate([
        MapProperty({ from: 'DigitalDiplomaCreateDate' })
    ], PublicDocument.prototype, "createDate", void 0);
    __decorate([
        MapProperty({ from: 'DigitalDiplomaRowId' })
    ], PublicDocument.prototype, "documentRowId", void 0);
    __decorate([
        MapProperty({ from: 'EmissionDate' })
    ], PublicDocument.prototype, "emissionDate", void 0);
    __decorate([
        MapProperty({ from: 'IsBlockChain' })
    ], PublicDocument.prototype, "isBlockChain", void 0);
    __decorate([
        MapProperty({ from: 'IsBlockChain2' })
    ], PublicDocument.prototype, "isBlockChain2", void 0);
    __decorate([
        MapProperty({ from: 'IsBlockChain2Approved' })
    ], PublicDocument.prototype, "isBlockChain2Approved", void 0);
    __decorate([
        MapProperty({ from: 'IsBlockChainSigned' })
    ], PublicDocument.prototype, "isBlockChainSigned", void 0);
    __decorate([
        MapProperty({ from: 'IsBlockChainSigned2' })
    ], PublicDocument.prototype, "isBlockChainSigned2", void 0);
    __decorate([
        MapProperty({ from: 'IsCertificateLandscape' })
    ], PublicDocument.prototype, "isDocumentLandscape", void 0);
    __decorate([
        MapProperty({ from: 'IsCertificateSigned' })
    ], PublicDocument.prototype, "isDocumentSigned", void 0);
    __decorate([
        MapProperty({ from: 'IsDemo' })
    ], PublicDocument.prototype, "isDemo", void 0);
    __decorate([
        MapProperty({ from: 'IsPrivate' })
    ], PublicDocument.prototype, "isPrivate", void 0);
    __decorate([
        MapProperty({ from: 'IsSuccess' })
    ], PublicDocument.prototype, "isSuccess", void 0);
    __decorate([
        MapProperty({ from: 'ErrorList' })
    ], PublicDocument.prototype, "errors", void 0);
    __decorate([
        MapProperty({ from: 'IsVerified' })
    ], PublicDocument.prototype, "isVerified", void 0);
    __decorate([
        MapProperty({ from: 'KeyWords' })
    ], PublicDocument.prototype, "keywords", void 0);
    __decorate([
        MapProperty({ from: 'MyValidateBlockChainReceiptData' })
    ], PublicDocument.prototype, "blockChainReceiptData", void 0);
    __decorate([
        MapProperty({ from: 'OgImageUrl' })
    ], PublicDocument.prototype, "originalDocumentImageUrl", void 0);
    __decorate([
        MapProperty({ from: 'ProgramName' })
    ], PublicDocument.prototype, "folderName", void 0);
    __decorate([
        MapProperty({ from: 'ProgramTitle' })
    ], PublicDocument.prototype, "folderTitle", void 0);
    __decorate([
        MapProperty({ from: 'SmartAdds', isArray: true, type: SmartAd })
    ], PublicDocument.prototype, "smartads", void 0);
    __decorate([
        MapProperty({ from: 'StudentName' })
    ], PublicDocument.prototype, "recipientName", void 0);
    __decorate([
        MapProperty({ from: 'PublicProfileUrl' })
    ], PublicDocument.prototype, "recipientPublicProfileUrl", void 0);
    __decorate([
        MapProperty({ from: 'PictureUrl' })
    ], PublicDocument.prototype, "recipientPictureUrl", void 0);
    __decorate([
        MapProperty({ from: 'ShortDescription' })
    ], PublicDocument.prototype, "recipientShortDescription", void 0);
    __decorate([
        MapProperty({ from: 'ClientRedirectURL' })
    ], PublicDocument.prototype, "publicDocumentRedirectUrl", void 0);
    __decorate([
        MapProperty({ from: 'IsClientRedirect' })
    ], PublicDocument.prototype, "isPublicDocumentRedirectActive", void 0);
    __decorate([
        MapSetMethod()
    ], PublicDocument.prototype, "setData", null);
    __decorate([
        MapGetMethod()
    ], PublicDocument.prototype, "getData", null);
    return PublicDocument;
}(ServiceDataBase));
export { PublicDocument };



//////////////////
// WEBPACK FOOTER
// ./src/modules/documents/models/PublicDocument.ts
// module id = null
// module chunks = 